// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609111050/js/" + chunkId + "." + {"44":"f47b4fce","225":"69640ae3","481":"8b5dead2","486":"3d68bfdb","770":"0f6cf7c9"}[chunkId] + ".0.7832735014735944.chunk.js";
};